import { createEffect } from '../utils/create-effect.mjs';
var propEffect = /*@__PURE__*/createEffect(function (subject, state, key, value) {
  return state.set(key, value, function () {
    subject[key] = state.latest[key];
  }, undefined, false);
});
export { propEffect };